/* VPV Slider — shared drag/swipe slider engine (Collection Slider, Reviews
   Slider, …). Reuses Impulse's theme.Slideshow (Flickity); no arrows. The
   progress bar fills from the visible fraction (at the start) to 100% (at the
   end). Each block builds the skeleton with these data hooks and styles it
   itself (card width, gap, colors all live in the block):
     [data-vpv-slider]        the root
     [data-vpv-slider-track]  the Flickity element (its children are the cards)
     [data-vpv-slider-bar]    the progress fill (optional) */
(function () {
  var OPTS = {
    cellAlign: 'left',
    wrapAround: false,
    pageDots: false,
    prevNextButtons: false,
    adaptiveHeight: false,
    contain: true,
    dragThreshold: 10
  };

  function setProgress(bar, flickity, progress) {
    var p = Math.max(0, Math.min(1, progress || 0));
    var total = flickity.slideableWidth || 0;
    var view = (flickity.size && flickity.size.innerWidth) || 0;
    if (!total || !view) {
      bar.style.width = (p * 100) + '%';
      return;
    }
    var visible = Math.min(1, view / total);
    var fill = visible + p * (1 - visible);
    bar.style.width = (Math.min(1, fill) * 100) + '%';
  }

  // Horizontal wheel / trackpad swipe → step through cards.
  function initWheelScroll(el, flickity) {
    if (el._vpvWheelHandler) el.removeEventListener('wheel', el._vpvWheelHandler);
    var accumulated = 0;
    var threshold = 150;
    function onWheel(e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      e.preventDefault();
      accumulated += e.deltaX;
      if (accumulated >= threshold) {
        flickity.next();
        accumulated = 0;
      } else if (accumulated <= -threshold) {
        flickity.previous();
        accumulated = 0;
      }
    }
    el._vpvWheelHandler = onWheel;
    el.addEventListener('wheel', onWheel, { passive: false });
  }

  function doInit(root, track, bar) {
    if (root.dataset.vpvSliderInit) return;
    if (track.classList.contains('flickity-enabled')) return;
    if (typeof theme === 'undefined' || typeof theme.Slideshow !== 'function') return;

    root.dataset.vpvSliderInit = '1';
    var obj = new theme.Slideshow(track, OPTS);
    root._vpvSlider = obj;
    var flickity = obj.slideshow;

    initWheelScroll(track, flickity);

    if (bar) {
      flickity.on('scroll', function (progress) { setProgress(bar, flickity, progress); });
      setProgress(bar, flickity, flickity.progress || 0);
    }
  }

  // Hidden containers (e.g. an inactive tab panel) report 0 width, so Flickity
  // can't measure them. Wait until the track is visible, then init.
  function deferInit(root, track, bar) {
    if (root.dataset.vpvSliderDeferred || typeof ResizeObserver === 'undefined') return;
    root.dataset.vpvSliderDeferred = '1';
    var ro = new ResizeObserver(function () {
      if (track.clientWidth > 0) {
        ro.disconnect();
        delete root.dataset.vpvSliderDeferred;
        doInit(root, track, bar);
      }
    });
    ro.observe(track);
  }

  function initSlider(root) {
    if (root.dataset.vpvSliderInit) return;
    var track = root.querySelector('[data-vpv-slider-track]');
    var bar = root.querySelector('[data-vpv-slider-bar]');
    if (!track || track.classList.contains('flickity-enabled')) return;

    if (track.clientWidth === 0) {
      deferInit(root, track, bar);
    } else {
      doInit(root, track, bar);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vpv-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-vpv-slider]');
    if (root && root._vpvSlider && typeof root._vpvSlider.destroy === 'function') {
      root._vpvSlider.destroy();
    }
  });
})();
